export interface MessageDelta {
  type: 'insert';
  chatId: string;
  message: any;
  conversation: any;
}

export function normaliseDelta(raw: any): MessageDelta | null {
  const conversation = Array.isArray(raw.conversation)
    ? raw.conversation[0]
    : (raw.conversation ?? null);

  const message = raw.newMessage ?? raw.messageList?.[0] ?? null;

  const chatId =
    conversation?.id ??
    message?.conversationId ??
    null;

  if (!chatId) return null;

  return { type: 'insert', chatId, message, conversation };
}
